import { render } from "./SidebarItem.vue?vue&type=template&id=9ddbfcb4&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=9ddbfcb4&lang=scss&scoped=true"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ddbfcb4"]])

export default __exports__